export enum BasketItemType {
  Offer = 'OFFER',
  Quote = 'QUOTE',
  Renewal = 'RENEW',
  RepairAndCare = 'QUOTERC',
}
